/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pro_User_Appreciation_Letter_Commitment_TitleInputs */

const en_pro_user_appreciation_letter_commitment_title = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our Promise Never Changes`)
};

const ar_pro_user_appreciation_letter_commitment_title = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وعدنا لا يتغير أبدًا`)
};

const de_pro_user_appreciation_letter_commitment_title = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unser Versprechen ändert sich nie`)
};

const es_pro_user_appreciation_letter_commitment_title = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuestra promesa nunca cambia`)
};

const fr_pro_user_appreciation_letter_commitment_title = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notre Promesse Reste Intacte`)
};

const it_pro_user_appreciation_letter_commitment_title = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La nostra promessa non cambia mai`)
};

const ja_pro_user_appreciation_letter_commitment_title = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`私たちの約束は変わりません`)
};

const ko_pro_user_appreciation_letter_commitment_title = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`변하지 않는 약속`)
};

const pt_br_pro_user_appreciation_letter_commitment_title = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nossa promessa nunca muda`)
};

const ru_pro_user_appreciation_letter_commitment_title = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Наше обещание неизменно`)
};

const th_pro_user_appreciation_letter_commitment_title = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คำมั่นสัญญาของเราไม่เคยเปลี่ยนแปลง`)
};

const tr_pro_user_appreciation_letter_commitment_title = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sözümüz Asla Değişmez`)
};

const zh_cn_pro_user_appreciation_letter_commitment_title = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`给你的承诺永远不变`)
};

const zh_tw_pro_user_appreciation_letter_commitment_title = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`給你的承諾永遠不變`)
};

/**
* | output |
* | --- |
* | "Our Promise Never Changes" |
*
* @param {Pro_User_Appreciation_Letter_Commitment_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const pro_user_appreciation_letter_commitment_title = /** @type {((inputs?: Pro_User_Appreciation_Letter_Commitment_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pro_User_Appreciation_Letter_Commitment_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pro_user_appreciation_letter_commitment_title(inputs)
	if (locale === "ar") return ar_pro_user_appreciation_letter_commitment_title(inputs)
	if (locale === "de") return de_pro_user_appreciation_letter_commitment_title(inputs)
	if (locale === "es") return es_pro_user_appreciation_letter_commitment_title(inputs)
	if (locale === "fr") return fr_pro_user_appreciation_letter_commitment_title(inputs)
	if (locale === "it") return it_pro_user_appreciation_letter_commitment_title(inputs)
	if (locale === "ja") return ja_pro_user_appreciation_letter_commitment_title(inputs)
	if (locale === "ko") return ko_pro_user_appreciation_letter_commitment_title(inputs)
	if (locale === "pt_br") return pt_br_pro_user_appreciation_letter_commitment_title(inputs)
	if (locale === "ru") return ru_pro_user_appreciation_letter_commitment_title(inputs)
	if (locale === "th") return th_pro_user_appreciation_letter_commitment_title(inputs)
	if (locale === "tr") return tr_pro_user_appreciation_letter_commitment_title(inputs)
	if (locale === "zh_cn") return zh_cn_pro_user_appreciation_letter_commitment_title(inputs)
	return zh_tw_pro_user_appreciation_letter_commitment_title(inputs)
});